/* eslint-disable @typescript-eslint/no-explicit-any */
import { ArrayField, ArrayFieldProps, ChipField, FunctionField, SingleFieldList } from 'react-admin';

export interface ChipArrayFieldProps extends ArrayFieldProps {
  choices?: { id: any; name: string }[];
  excludeChoices?: any[];
}

export const ChipArrayField: React.FC<ChipArrayFieldProps> = (props) => {
  const render = (id: any) =>
    props.excludeChoices?.includes(id) ? null : (
      <ChipField
        record={{ id: id, name: props.choices?.find((choice) => choice.id == id)?.name ?? id }}
        source="name"
      />
    );

  return (
    <ArrayField {...props}>
      <SingleFieldList linkType={false}>
        <FunctionField render={render} source="name" />
      </SingleFieldList>
    </ArrayField>
  );
};
